import { render } from "./AttributeJsonTree.vue?vue&type=template&id=09609abb&scoped=true"
import script from "./AttributeJsonTree.vue?vue&type=script&lang=js"
export * from "./AttributeJsonTree.vue?vue&type=script&lang=js"

import "./AttributeJsonTree.vue?vue&type=style&index=0&id=09609abb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09609abb"]])

export default __exports__